import countriesData from '@assets/data/countries.json';

export interface ParsedPhoneNumber {
  phone: string;
  countryCode: string;
  dialCode: string;
}

export const parsePhoneNumber = (phoneNumber: string): ParsedPhoneNumber => {
  if (!phoneNumber) return { phone: '', countryCode: '', dialCode: '' };

  const normalizedPhone = phoneNumber.replace(/\s+/g, '');

  const country = countriesData.find((country) =>
    normalizedPhone.startsWith(country.dial_code)
  );

  if (country) {
    const phoneWithoutCode = normalizedPhone.substring(
      country.dial_code.length
    );
    return {
      phone: country.dial_code + phoneWithoutCode,
      countryCode: country.code,
      dialCode: country.dial_code
    };
  }

  return { phone: normalizedPhone, countryCode: '', dialCode: '' };
};
